import { TabHandler, TabViewState, TabType, registerTabHandler } from 'owa-tab-store';
import { lazyPrepareAddinCommunicationInPopout } from 'owa-addins-common-utils';
import { getComposeHostItemIndex } from 'owa-addins-core';
import { getOrCreateSxSStoreData } from 'owa-sxs-store';

const SxSTabHandler: TabHandler = {
    onPopout: (viewState: TabViewState, targetWindow: Window) => {
        const composeId = getOrCreateSxSStoreData(viewState.sxsId).composeId;
        lazyPrepareAddinCommunicationInPopout.importAndExecute(
            targetWindow,
            getComposeHostItemIndex(composeId)
        );
    },
};

export default function ensureSxSTabHandler() {
    registerTabHandler(TabType.SxS, SxSTabHandler);
}
